module.exports = __webpack_public_path__ + "img/access.f7c22a26.jpg";